import {
  SR_API_ACTION_CANCEL_TOUR,
} from 'api/actionTypes';

import getToursList from './getList';

export default async function cancelTour({ state, history, apiClient }, {
  tourId,
  tourCancelReason,
  cancelReasonUserProvided,
}) {
  await apiClient.postWithState({
    action: SR_API_ACTION_CANCEL_TOUR,
    state: state,
    payload: {
      tourId,
      tourCancelReason,
      cancelReasonUserProvided,
    },
    onSuccess() {
      history.push('/tour');
    },
  });

  await getToursList({ state, apiClient }, { reloadTours: true });
}
